import * as VueRouter from 'vue-router';
import ClassroomPage from '@/pages/ClassroomPage.vue';
import JourneyPage from '@/pages/JourneyPage.vue'; 
import Pickcode from '@/pages/platforms/Pickcode.vue';

const routes = [
  {
    name: 'Home', path: '/',
    beforeEnter() { window.location.replace("https://www.cococoders.com") }
  },
  { name: 'Journey', path: '/journey/:studentUuid/:studentName?', component: JourneyPage },
  { name: 'DeviceCheck', path: '/check', component: ClassroomPage },
  { name: 'StudentJoin', path: '/join/:studentUuid/:studentName?', component: ClassroomPage },
  { name: 'ClassroomTestTeacher', path: '/classroom/test/t/:teacherUuid?', component: ClassroomPage },
  { name: 'ClassroomTestStudent', path: '/classroom/test/:teacherUuid?', component: ClassroomPage },
  { name: 'ClassroomTeacher', path: '/classroom/t/:lessonUuid/:teacherUuid?', component: ClassroomPage },
  { name: 'ClassroomStudent', path: '/classroom/:lessonUuid/:studentUuid?', component: ClassroomPage },
  { name: 'Pickcode', path: '/platforms/python', component: Pickcode },
];

const router = VueRouter.createRouter({
  history: VueRouter.createWebHistory(),
  routes
});

export default router;